/**
 * 하단 탭이 붙는 화면의 틀 (상회칠판, 별채대화, 나). Todak 의 ShellWithTabs 와 같은 역할입니다.
 * 화면은 자기 스크롤 영역을 갖고, 탭은 아래에 고정됩니다.
 * 키보드가 올라와 있으면 탭을 숨겨 입력창 · 대화가 그 자리를 씁니다(앱, DEV-13 0).
 */
import { Outlet } from 'react-router-dom';
import { BottomTabs } from './BottomTabs.jsx';
import { useKeyboardOpen } from '../hooks/useKeyboardOpen.js';

export function TabLayout() {
    const keyboardOpen = useKeyboardOpen();
    return (
        <div className="flex h-dvh flex-col">
            <div className="flex min-h-0 flex-1 flex-col">
                <Outlet />
            </div>
            {keyboardOpen ? null : <BottomTabs />}
        </div>
    );
}
